import React from 'react';
import './App.css';

const AlphaModel = () => {
  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col-12 text-center">
          <h1>AM</h1>
        </div>
      </div>
    </div>
  );
};

export default AlphaModel;